import '../assets/css/ConfirmInvoice.scss'
import AppCartController from "../../Main/controller/AppCartController";
import React from "react";
import InvoiceInterface from "../interface/invoiceInterface";
import DiscountController from "../Controller/DiscountController";
import {useTranslation} from "react-i18next";

export default function Confirm({state, setState}: {
    state: InvoiceInterface,
    setState: React.Dispatch<React.SetStateAction<InvoiceInterface>>
}) {
    const {t} = useTranslation();
    const clearCart = () => {
        AppCartController.clearCart()
        new DiscountController(state, setState).clearDiscount()
        window.dispatchEvent(new Event('closeModal'))
    }

    return (
        <div className="confirm-invoice-container">
            <h3>{t("invoice.removeCartTitle")}</h3>
            <p>
                {t("invoice.removeCartDescription")}
            </p>
            <div className="footer">
                <button className={'stroke-btn'} onClick={() => window.dispatchEvent(new Event('closeModal'))}>
                    {t("invoice.backToMainPage")}
                </button>
                <button className={'primary-btn'} onClick={() => clearCart()}>
                    {t("invoice.removeCartTitle")}
                </button>
            </div>
        </div>
    );
}